(() => {
  const VISIBLE_DESKTOP = 4; // tu grid: 4 columnas

  function getScroller(section) {
    // Horizon: el scroller real
    return section.querySelector('slideshow-slides[ref="scroller"]')
      || section.querySelector('slideshow-slides');
  }

  function initSection(section) {
    const carousel = section.querySelector('.resource-list__carousel');
    if (!carousel) return;

    const scroller = getScroller(section);
    if (!scroller) return;

    // items reales
    const items = section.querySelectorAll('slideshow-slide.resource-list__slide');
    if (!items.length) return;

    const pages = Math.max(1, Math.ceil(items.length / VISIBLE_DESKTOP));

    // crear / reutilizar paginación
    let pager = section.querySelector('.hc-pagination');
    if (!pager) {
      pager = document.createElement('div');
      pager.className = 'hc-pagination';
      carousel.insertAdjacentElement('afterend', pager);
    }

    pager.innerHTML = '';
    const buttons = [];

    function setActive(i) {
      buttons.forEach((b, idx) => b.classList.toggle('is-active', idx === i));
    }

    for (let i = 0; i < pages; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'hc-bar';
      b.setAttribute('aria-label', `Go to page ${i + 1}`);

      b.addEventListener('click', (e) => {
        // CLAVE: que el click NO genere scroll del documento
        e.preventDefault();
        e.stopPropagation();

        // scroll SOLO dentro del carrusel
        const w = scroller.clientWidth || 1;
        scroller.scrollTo({ left: i * w, behavior: 'smooth' });

        // evita “auto scroll” por focus
        if (b.blur) b.blur();

        setActive(i);
      });

      pager.appendChild(b);
      buttons.push(b);
    }

    // actualizar activo al scroll
    scroller.addEventListener('scroll', () => {
      const w = scroller.clientWidth || 1;
      const page = Math.max(0, Math.min(pages - 1, Math.round(scroller.scrollLeft / w)));
      setActive(page);
    }, { passive: true });

    setActive(0);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.shopify-section').forEach(initSection);
  });
})();
